import React from 'react';
import PropTypes from 'prop-types';
import '../../Login/login.scss';
import SideColumn from '../../Login/SideColumn';
import logo from '../../../images/pacer-logo-white.png';
import LoginFooter from '../../Login/LoginFooter';

export class LoginStyleWrapper extends React.Component {
    constructor(props, context) {
        super(props, context);

    }

    render() {
        return (
            <div className="login-page">

                <div className="content-column">
                    <header>
                        <img src={logo} alt="Pacer" width="300" />
                    </header>
                    <main>
                        <div className={(this.props.isWide) ? "form-container wide" : "form-container"}>
                            {this.props.children}
                        </div>
                    </main>
                    <LoginFooter showSignUpButton={this.props.showSignUpButton} />
                </div>                    

                <SideColumn />
            </div>
        );
    }
}

LoginStyleWrapper.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ]),
    subscriptionId: PropTypes.number,
    showSignUpButton: PropTypes.bool,
    isWide: PropTypes.bool
};

LoginStyleWrapper.defaultProps = {
    showSignUpButton: true,
    isWide: false
}

export default LoginStyleWrapper;